import { render, staticRenderFns } from "./ProposalVariantModal.vue?vue&type=template&id=56704e46&"
import script from "./ProposalVariantModal.vue?vue&type=script&lang=js&"
export * from "./ProposalVariantModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports